import React from 'react';
import Game from './Game';  // Assuming Game.js is in the same folder

const App = () => {
    return (
        <div>
            <Game />
        </div>
    );
};

export default App;
